export const themeClasses = {
  'mixed': {
    type: 'Mixed',
    color: 'bg-brand-accent',
    text: 'text-brand-accent',
    bg: 'bg-brand-accent',
    lightBg: 'bg-brand-accent/10',
    border: 'border-brand-accent',
    lightBorder: 'border-brand-accent/10',
    ring: 'focus:ring-brand-accent/20',
    shadow: 'shadow-brand-accent/20',
    iconBg: 'bg-brand-accent/10'
  },
  'qa': {
    type: 'Q&A',
    color: 'bg-brand-indigo',
    text: 'text-brand-indigo',
    bg: 'bg-brand-indigo',
    lightBg: 'bg-brand-indigo/10',
    border: 'border-brand-indigo',
    lightBorder: 'border-brand-indigo/10',
    ring: 'focus:ring-brand-indigo/20',
    shadow: 'shadow-brand-indigo/20',
    iconBg: 'bg-brand-indigo/10'
  },
  'brainstorm': {
    type: 'Brainstorm',
    color: 'bg-cyan-500',
    text: 'text-cyan-500',
    bg: 'bg-cyan-500',
    lightBg: 'bg-cyan-50',
    border: 'border-cyan-500',
    lightBorder: 'border-cyan-100',
    ring: 'focus:ring-cyan-500/20',
    shadow: 'shadow-cyan-200/50',
    iconBg: 'bg-cyan-50'
  },
  'poll': {
    type: 'Poll',
    color: 'bg-purple-600',
    text: 'text-purple-600',
    bg: 'bg-purple-600',
    lightBg: 'bg-purple-50',
    border: 'border-purple-600',
    lightBorder: 'border-purple-100',
    ring: 'focus:ring-purple-500/20',
    shadow: 'shadow-purple-200/50',
    iconBg: 'bg-purple-50'
  }
};

export const getTheme = (type) => {
  const t = type?.toLowerCase();
  if (t === 'mixed') return themeClasses['mixed'];
  if (t === 'q&a' || t === 'qa' || t === 'live') return themeClasses['qa'];
  if (t === 'brainstorm' || t === 'brainstorming') return themeClasses['brainstorm'];
  if (t === 'poll') return themeClasses['poll'];
  return themeClasses['mixed'];
};
